import React from 'react';
import { Collapse } from 'reactstrap';
import { isNullOrUndefined } from "../../store/storeFunctions";
import { Translate, withLocalize } from 'react-localize-redux';
import classnames from 'classnames';
import Message from '../common/message'
import SearchTip from '../common/searchTip';

import "./marketingSection.scss";

class MarketingSection extends React.Component {

    render() {
        return (<>
            {this.props.searchTip &&
                <SearchTip windowId={`tips_unicorn_${this.props.section}_${this.props.field || ""}`} getSearchTipsModel={() => this.getSearchTipsModel(this.props.searchTip)} />}
            <div className={classnames({ 'marketing-list-section': true, 'is-expanded': true })}
                style={this.props.style}
            >
                <div className="header-body">
                    <div className="name">{this.props.name}</div>
                </div>
                <Collapse isOpen={true} name={this.props.name}>
                    {this.props.section && this.props.errors && this.renderErrors(this.props.section, this.props.errors, this.props.field)}
                    <div className='section-body'>
                        {this.props.children}
                    </div>
                </Collapse>
            </div>
        </>)
    }

    getSearchTipsModel = (searchTip) => {
        return { title: this.props.name, bodyHtml: searchTip };
    }

    renderErrors = (section, errors, field = "") => {
        if (isNullOrUndefined(errors) || Object.keys(errors).length === 0 || (isNullOrUndefined(errors[section]) && isNullOrUndefined(errors[field])))
            return null;

        let sectionErrors = isNullOrUndefined(errors[section]) ? Object.keys(errors[field]) : Object.keys(errors[section]);
        return (sectionErrors.length > 0 &&
            <div className="column">
                <Message type="error" message={this.props.translate("Error.InvalidParams")} shadowed>
                    <ul style={{ listStyleType: "disc" }}>
                        {this.filterTranslatedErrors(sectionErrors, section).map(k => <li key={k} style={{ marginLeft: "3em" }}>{k}</li>)}
                    </ul>
                </Message>
            </div>);
    }

    filterTranslatedErrors = (sectionErrors, section) => sectionErrors.map(k => this.translateErrorItem(section, k)).filter((item, pos, self) => self.indexOf(item) === pos); // distinct

    translateErrorItem = (section, item) =>
        (item === null || item === null || item.length < 1) ? null : this.props.translate(`MarketingList.Error.${section[0].toUpperCase()}${section.slice(1)}.${item[0].toUpperCase()}${item.slice(1)}`)
}

export default withLocalize(MarketingSection);